import React from 'react';
import Rebel from'../images/rebel.jpeg';

function Work() {
 let url = fetch("https://dorset.localplacedirectory.org.uk/Aggregator/Services", {mode: 'no-cors', method: 'GET', redirect: 'follow', headers:{"Content-Type":"application/json"}});

 if(url !== ""){
 fetch(url)
  .then((response) => console.log("response: ",response.json()))
  .then((result) => console.log("result: ",result))
  .catch((error) => console.error(error))
 }


  return (
  

    <div id="funPage">
       <h2>Work</h2>    
      <div id="content">
      Work ... boooo!
        </div>  
    </div>
    
  )
}

export default Work;
